export const CYPHER = 'cypher';
export const DECRYPTION = 'decryption';
export const DECRYPTION_FAILED = 'decryptionFailed';
export const DECRYPTION_IN_PROGRESS = 'decryptionInProgress';
export const DECRYPTION_SUCCESS = 'decryptionSuccess';
